import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { Row, Col, Card, CardHeader, Button } from "reactstrap"
import { saveTipEnabledConfiguration } from "../../apollo/server"
import { useMutation, gql } from "@apollo/client"
import { Alert } from "reactstrap/lib"

interface IProps {
  tipEnabled: boolean
}

// 配達員チップ機能のフィーチャーフラグ。ON にすると顧客アプリのカート(カード決済時)に
// チップ選択UIが表示される。会計向けの月次集計は「チップ集計」ページで確認できる。
const TipEnabled: React.FC<IProps> = props => {
  const { t } = useTranslation()
  const [tipEnabled, setTipEnabled] = useState(props.tipEnabled)
  const [successMessage, setSuccessMessage] = useState("")
  const [errorMessage, setErrorMessage] = useState("")

  const [save, { loading, error }] = useMutation(gql`${saveTipEnabledConfiguration}`, {
    onCompleted: result => {
      setSuccessMessage(result.saveTipEnabledConfiguration.tipEnabled ? t("TipEnabledOnMessage") : t("TipEnabledOffMessage"))
    },
    onError: e => {
      setErrorMessage(t("ErrorMessage"))
      console.log(e)
    },
  })
  if (error) return <p>{t("Error")}</p>

  function submit(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    e.preventDefault()
    if (loading) return
    save({ variables: { tipEnabled } })
  }

  const onDismiss = () => {
    setSuccessMessage("")
    setErrorMessage("")
  }

  return (
    <Row className="mt-3">
      <div className="col">
        <Card className="shadow">
          <CardHeader className="border-0">
            <h3 className="mb-0">{t("TipEnabledTitle")}</h3>
            <small className="text-muted">{t("TipEnabledHint")}</small>
          </CardHeader>

          <Row className="ml-3 mr-3" style={{ display: "flex", alignItems: "center" }}>
            <Col md="10">
              <label className="custom-toggle">
                <input
                  name="input-tip-enable"
                  checked={tipEnabled}
                  type="checkbox"
                  onChange={e => setTipEnabled(e.target.checked)}
                />
                <span className="custom-toggle-slider rounded-circle" />
              </label>
            </Col>
            <Col md="2">
              <Button className="btn-block mb-2" type="button" color="primary" onClick={submit} size="lg">
                {loading ? t("Saving") : t("Save")}
              </Button>
            </Col>
          </Row>
          <Row className="mx-3" style={{ display: "flex", justifyContent: "flex-end" }}>
            <Col md="6">
              <Alert color="success" isOpen={!!successMessage} toggle={onDismiss}>
                <span className="alert-inner--icon">
                  <i className="ni ni-like-2" />
                </span>{" "}
                <span className="alert-inner--text" style={{ whiteSpace: "pre-wrap" }}>
                  <strong>{t("Success")}! </strong>
                  {successMessage}
                </span>
              </Alert>
              <Alert color="danger" isOpen={!!errorMessage} toggle={onDismiss}>
                <span className="alert-inner--icon">
                  <i className="ni ni-like-2" />
                </span>{" "}
                <span className="alert-inner--text">
                  <strong>{t("Danger")}!</strong> {errorMessage}
                </span>
              </Alert>
            </Col>
          </Row>
        </Card>
      </div>
    </Row>
  )
}
export default TipEnabled
